import { render, staticRenderFns } from "./EzUserList.vue?vue&type=template&id=37e0b660&scoped=true&"
import script from "./EzUserList.vue?vue&type=script&lang=js&"
export * from "./EzUserList.vue?vue&type=script&lang=js&"
import style0 from "./EzUserList.vue?vue&type=style&index=0&id=37e0b660&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e0b660",
  null
  
)

export default component.exports